import { faker } from '@faker-js/faker';
import { RewardCode } from '@shared/constants';

const rewardCodeTypes: RewardCode[] = [
  RewardCode.TEXT,
  RewardCode.CODE,
  RewardCode.QRCODE,
  RewardCode.BARCODE,
  RewardCode.IMAGE_LINK,
  RewardCode.CLICKABLE_LINK,
];

const categories = [
  'Electronics',
  'Fashion',
  'Home & Garden',
  'Health & Beauty',
];

export class MockReward {
  reward_id!: string;
  reward_bank_id!: string;
  label = faker.lorem.sentence();
  sublabel = faker.lorem.sentence();
  additional_details = faker.lorem.paragraph();
  code_details!: { type: string; value: string };
  terms_and_conditions = faker.lorem.paragraph();
  banner_link = 'assets/images/default/banner.webp';
  expiration_date: string = faker.date.soon().toISOString();
  category_name!: string;
  activations_left = faker.number.int({ min: 1, max: 100 });
  price_to_unlock = faker.number
    .float({ min: 1, max: 20, fractionDigits: 2 })
    .toString();
  category_display_order: number | null = null;

  constructor(isActivated = false) {
    if (isActivated) {
      const codeType = faker.helpers.arrayElement(rewardCodeTypes);
      this.code_details = generateCodeDetailsfromCodeType(codeType);
    }
    this.category_name = faker.helpers.arrayElement(categories);
  }
}

type Options = {
  length?: number; // total rewards
  isActive?: boolean;
  nullCategoriesRate?: number; // probability a category has displayOrder null
};

export const generateRewards = ({
  length = 20,
  isActive = false,
  nullCategoriesRate = 0.25,
}: Options = {}): MockReward[] => {
  faker.seed(123); // make seed deterministic

  // Assign ONE displayOrder per category (consistent)
  const shuffled = faker.helpers.shuffle([...categories]);

  const categoryToDisplayOrder = new Map<string, number | null>();
  shuffled.forEach((cat, idx) => {
    const isNull = faker.number.float({ min: 0, max: 1 }) < nullCategoriesRate;
    categoryToDisplayOrder.set(cat, isNull ? null : idx); // unique non-null by index
  });

  // Create rewards, each reward inherits its category's displayOrder
  const result: MockReward[] = [];
  for (let i = 0; i < length; i++) {
    const r = new MockReward(isActive);
    r.reward_bank_id = '100';
    r.reward_id = (i + 1).toString();

    r.category_name = faker.helpers.arrayElement(categories);
    r.category_display_order = categoryToDisplayOrder.get(r.category_name)!;
    result.push(r);
  }

  return result;
};

export const generateCodeDetailsfromCodeType: (codeType: RewardCode) => {
  type: string;
  value: string;
} = (codeType: RewardCode) => {
  if (codeType === RewardCode.TEXT) {
    return {
      value: '364728283834',
      type: codeType,
    };
  } else if (codeType === RewardCode.IMAGE_LINK) {
    return {
      type: codeType,
      value: faker.image.url({ width: 450, height: 450 }),
    };
  } else if (codeType === RewardCode.CLICKABLE_LINK) {
    return {
      type: codeType,
      value: faker.internet.url(),
    };
  } else if (codeType === RewardCode.BARCODE) {
    return {
      type: codeType,
      value: '123456789012', // UPC format (12 digits)
    };
  } else if (codeType === RewardCode.QRCODE) {
    return {
      type: codeType,
      value: 'https://www.example.com/reward/364728283834',
    };
  } else {
    return {
      type: codeType,
      value: 'SAVE20NOW',
    };
  }
};
